
import {Component, OnDestroy, OnInit} from '@angular/core';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {filter, first, takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {SettlementTemplateService} from '../../../shared/services/settlement-template.service';
import {SettlementTemplate} from '../../../shared/interface/settlement-template';
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {InsuranceCompanyService} from "../../../shared/services/insurance-company.service";
import {FileInput, FileValidator} from "ngx-material-file-input";

@Component({
  selector: 'app-tu-template',
  templateUrl: './tu-template.component.html',
  styleUrls: ['./tu-template.component.scss']
})
export class TuTemplateComponent implements OnInit, OnDestroy {
  fileMaxSize = 5242880;
  importCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  insuranceCompanyControl: FormControl;
  fileNameControl: FormControl;
  fileContentControl: FormControl;
  companyObject?: InsuranceCompany = null;
  TU = false;
  fileControl: FormControl;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Wprowadź treść email..',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      [
        'insertImage',
        'insertVideo',
      ]
    ]
  };

  templateForm: FormGroup;
  contentEmailControl: FormControl;
  currentTemplateObject: InsuranceCompany;
  processingRequest = false;
  errors: any = {};
  fileLocation = false;
  temp = '{tabela}';

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private insuranceCompanyService: InsuranceCompanyService,
  ) {
    this.templateForm = this.fb.group({
      file: this.fileControl = fb.control(''),
      fileName: this.fileNameControl = fb.control(''),
      fileContent: this.fileContentControl = fb.control(''),
      contentEmail: this.contentEmailControl = fb.control('', [Validators.required]),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((files?: File[]) => files?.length > 0)
      )
      .subscribe((files: File[]) => {
        this.fileNameControl.setValue(files[0].name);
        this.fileContentControl.reset('');

        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.fileContentControl.setValue(/base64,(.+)/.exec(reader.result.toString())[1]);
        };
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  initialize(id: string): void {
    this.fileLocation = false;
    this.insuranceCompanyService.get(id)
      .subscribe((insuranceCompany: InsuranceCompany) => {
        this.currentTemplateObject = insuranceCompany;
        this.contentEmailControl.setValue( this.currentTemplateObject.contentEmail);
        if (this.currentTemplateObject.fileLocation === null){
          this.fileLocation = true;
        }
      });
  }


  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.TU = true;
    this.companyObject = insuranceCompany;
    this.initialize(insuranceCompany.id.toString());
  }
  download(): void {
    this.insuranceCompanyService.downloadFile(this.currentTemplateObject.id);
  }

  delete(): void {
    this.insuranceCompanyService.deleteFile(this.currentTemplateObject.id)
      .subscribe(() => {
          this.snackBar.open('Pomyślnie usunięto szablon', '', {duration: 2000});
          this.insuranceCompanyChanged(this.currentTemplateObject);
        });
  }

  save(): void {
    this.processingRequest = true;
    this.insuranceCompanyService.updateContent(
      this.templateForm.value,
    this.companyObject.id
  )
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snackBar.open('Pomyślnie zapiszano szablon', '', {
          duration: 2000,
        });
        this.processingRequest = false;
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.templateForm, this.errors);
        }
      });
  }

}
